export const BOOKING_REFERENCE_FIELDS = [
  'confirmation_number',
  'booking_invoice_number',
  'booking_code',
  'invoice_number',
  'confirmationNumber',
  'invoiceNumber',
];

const NESTED_BOOKING_FIELDS = [
  'booking',
  'exclusive_booking',
  'non_exclusive_booking',
];

function cleanReference(value) {
  if (value === null || value === undefined) return null;
  const ref = String(value).trim();
  return ref || null;
}

function sourceCandidates(source) {
  if (!source || typeof source !== 'object') return [];

  return [
    source,
    ...NESTED_BOOKING_FIELDS.map(field => source[field]).filter(candidate => candidate && typeof candidate === 'object'),
  ];
}

export function getOperationalBookingReference(source) {
  const candidates = sourceCandidates(source);

  for (const field of BOOKING_REFERENCE_FIELDS) {
    for (const candidate of candidates) {
      const ref = cleanReference(candidate[field]);
      if (ref) return ref;
    }
  }

  return null;
}

function getFallbackId(source, fallbackId) {
  if (fallbackId !== null && fallbackId !== undefined && fallbackId !== '') {
    return fallbackId;
  }
  if (!source || typeof source !== 'object') return null;

  return (
    source.bookingId ??
    source.booking_id ??
    source.exclusive_booking_id ??
    source.non_exclusive_booking_id ??
    source.booking?.id ??
    source.exclusive_booking?.id ??
    source.non_exclusive_booking?.id ??
    null
  );
}

export function getBookingReference(source, options = {}) {
  const ref = getOperationalBookingReference(source);
  if (ref) return ref;

  const fallbackId = getFallbackId(source, options.fallbackId);
  return fallbackId !== null && fallbackId !== undefined && fallbackId !== ''
    ? `Booking #${fallbackId}`
    : 'Booking';
}

export function sanitizeBookingReferenceForFilename(reference, fallback = 'booking') {
  const sanitized = cleanReference(reference)
    ?.replace(/[^A-Za-z0-9._-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

  return sanitized || fallback;
}

export function getBookingReferenceFilenameToken(source, options = {}) {
  return sanitizeBookingReferenceForFilename(getBookingReference(source, options));
}
